import MonitoringQueueEntriesPage from './MonitoringQueueEntriesPage';

export default MonitoringQueueEntriesPage;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/pages/monitoring-queue-entries-page/index.js